








































import OrderContentTop from '@/components/common/order/OrderContentTop.vue';
import ItemTable from '@/components/common/order/ItemTable.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import OrderDeposit from '@/components/order/mixins/OrderDeposit';

import { Component, Mixins, Ref } from 'vue-property-decorator';
import {ncpPopup} from '@/utils/commonUtils';
import {CustomGroupFlagCallbackInfo} from '@/components/common/order/mixins/OrderGridsColums';
import OrderGridBrokenFreeGiftMixin from '@/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue';

@Component({
  components: {OrderContentTop, PageTitle, ItemTable}
})
export default class OrderListDeposit extends Mixins(OrderDeposit, OrderGridBrokenFreeGiftMixin) {
  @Ref('gridBottom')
  private readonly gridRef: ItemTable;

  private orderListContent: any = [];
  private totalCount: any = 0;
  private initPageSize: number = 30;
  private theExcelDownIfo: any = {
    fileName: '',
    columns: {},
    formatters: {}
  };
  private request: any = {
    params: {}
  };
  private memberGroup: any[] = [];
  private showMemberGroup: boolean = false;
  private memberGroupData: any = {
    id: 'memberGroup',
    width: 400,
    maxHeight: 300,
    title: 'ORDER_LIST_GRIDS_MEMBER_GROUP_LAYER_TITLE',
    nonFooter: false,
    hasConfirmBtn: false
  };
  private contentBottomOption: any = {
    haveConfigBtn: true,
    haveExcelDownBtn: true,
    excelDownInfo: {
      columns: {},
      fileName: '',
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {}
    }
  };

  private created(): void {}
  private mounted(): void {
    $('body').on('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    // $('body').on('click', '.changeStatusGroup', $.proxy(this.changeStatusBtnClick, this));
    $('body').on('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    $('body').on(
      'click',
      '.tui-grid-content-area input[name="_checked"]',
      $.proxy(this.checkGroupRow, this)
    );
  }
  private destroyed(): void {
    $('body').off('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    // $('body').off('click', '.changeStatusGroup', $.proxy(this.changeStatusBtnClick, this));
    $('body').off('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    $('body').off(
      'click',
      '.tui-grid-content-area input[name="_checked"]',
      $.proxy(this.checkGroupRow, this)
    );
  }
  private clickMemberGroupNameInGrid(e: any): void {
    this.memberGroup = [];
    this.memberGroup = JSON.parse($(e.target).data('json').replace(/\\\"/g, '"'));
    this.showMemberGroup = true;
  }
  private orderNameClick(e: any): void {
    const memberno = $(e.target).data('memberno');
    ncpPopup(`/member/popup/crm/${memberno}`, 'ORDER_LIST_GRIDS_ORDER_NAME_POPUP_TITLE', 1100, 980);
  }
  private changeDepositStatus(rowKey: number): void {
    const item = this.gridRef.getRowItems(rowKey);
    const isBrokenFreeGiftCondition = item.freeGiftConditionBrokenType === 'CLAIM_DONE';
    const confirmMessage = isBrokenFreeGiftCondition ? 'ORDER_LIST_GRIDS_FREE_GIFT_CONDITION_IS_BROKEN' : 'ORDER_LIST_GRIDS_CHANGE_STATUS_CONFIRM';

    if (!confirm(`${this.$t(confirmMessage)}`)) return;


    this.$api.putPaymentsConfirm([item.orderNo]).then(() => {
      alert(this.$t('ORDER_LIST_GRIDS_PAY_CONFIRM_HANDLE_DONE'));
      this.search(1, this.size);
    });
  }
  private getRowItems(rowKey: any): any {
    return (this.$refs.gridBottom as any).getRowItems(rowKey);
  }
  private handleInitRequest(e: any): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
  }
  public initExcelColums(): void {
    let columns: any = this.gridProps.columns.map((item: any) => {
      if(item.visible === true) {
        return item.name;
      }
    });
    this.contentBottomOption.excelDownInfo.columns = [];
    columns.forEach((el: any): any => {
      this.contentBottomOption.excelDownInfo.columns[el] = this.excelDownInfo.columns[el];
    });
    this.contentBottomOption.excelDownInfo.formatters = this.excelDownInfo.formatters;
    this.contentBottomOption.excelDownInfo.fileName = 'order_pending_';
  }
  private handleSearch(e: any, page: number = 1): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
    this.request.params.orderStatusType = 'DEPOSIT_WAIT';
    this.request.params.page = page || 1;
    this.request.params.size = this.size;
    $('#loading').show();
    this.$api
      .getOrderOptionsOrderGrid(this.request)
      .then((res) => {
        this.orderListContent = [];
        let content: any = res.data.contents;
        if (res.data.contents.length > 0) {
          this.orderListContent = [...this.formatterList(content, 'orderDeliveryGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
          let bigRow = ['platformType', 'mallNo', 'orderRegisterType', 'reservation', 'memberGroupInfoJson', 'payType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo', 'procBtn', 'procEachBtn'];
          let midRow = [
            'receiverName',
            'receiverContact1',
            'receiverZipCd',
            'address',
            'shippingNo',
            'deliveryMemo',
            'customsIdNumber',
            'deliveryType',
            'deliveryCompanyType',
            'invoiceNo',
            'deliveryAmtInAdvanceYn',
            'adjustedAmt',
            'remoteDeliveryAmt',
            'lastSubPayAmt',
            'lastMainPayAmt',
          ];
          let smallRow: any[] = ['shippingAreaType', 'partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];

	        const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		        small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	        }

          this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'orderNo', 'shippingNo', 'mallProductNo', customGroupFlagCallbackInfo)];
        }
        this.setCommunicateFailBgColor(this.orderListContent,this.$refs.gridBottom);
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally((): any => {
        $('#loading').hide();
      });
  }
  private handleCancel(): void {}

  private search(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }
    this.request.params.orderStatusType = 'DEPOSIT_WAIT';
    this.request.params.page = page;
    this.request.params.size = this.size;
    $('#loading').show();
    this.$api
      .getOrderOptionsOrderGrid(this.request)
      .then((res) => {
        this.orderListContent = [];
        let content: any = res.data.contents;
        if (res.data.contents.length > 0) {
          this.orderListContent = [...this.formatterList(content, 'orderDeliveryGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
          let bigRow = ['platformType', 'mallNo', 'orderRegisterType', 'reservation', 'memberGroupInfoJson', 'payType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo', 'procBtn', 'procEachBtn',
            'lastSubPayAmt',
            'lastMainPayAmt',];
          let midRow = [
            'receiverName',
            'receiverContact1',
            'receiverZipCd',
            'address',
            'shippingNo',
            'deliveryMemo',
            'customsIdNumber',
            'deliveryType',
            'deliveryCompanyType',
            'invoiceNo',
            'deliveryAmtInAdvanceYn',
            'adjustedAmt',
            'remoteDeliveryAmt'
          ];
          let smallRow: any[] = ['shippingAreaType', 'partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];

	        const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		        small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	        }

          this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'orderNo', 'shippingNo', 'mallProductNo', customGroupFlagCallbackInfo)];
        }
        this.setCommunicateFailBgColor(this.orderListContent,this.$refs.gridBottom);
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally((): any => {
        $('#loading').hide();
      });
  }
  private getCheckedItems(arr: any): any {
    return (this.$refs.gridBottom as any).getCheckedItems(arr);
  }

  private handlePut(e: any): void {
    this.changeStatus(e);
  }

  private changeStatus(e: any) {
    const targetStatusType = $(e.target).attr('to')||$(e.currentTarget).attr('to');
		this.checkSelectedList(this.gridRef.getCheckedRows(), targetStatusType);
  }

	// LINK: src/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue
	protected changeOrderStatus(items, orderStatusType) {
		this.checkSelectedList(items, orderStatusType, false);
	}

	private checkSelectedList(checkedRowList, targetStatusType, useConfirm = true) {
		if (checkedRowList.length === 0) {
			if (targetStatusType === 'PAY_DONE') {
				alert(this.$t('ORDER_LIST_GRIDS_DEPOSIT_NOT_CHECK_ROW_ALERT'));
			} else {
				alert(this.$t('ORDER_LIST_GRIDS_PAY_DONE_NOT_CHECK_ROW_ALERT'));
			}
			return;
		}

		const confirmMessage: any = this.$t('ORDER_LIST_GRIDS_CONFIRM_HANDLE_CHANGE');

		if (useConfirm && !confirm(confirmMessage)) {
			return;
		}

		this.changeStatusProcs(targetStatusType, checkedRowList, true, 'DEPOSIT_WAIT', false);
	}
  private changeStatusProcs(targetStatusType: any, checkedRowList: any, successAlert: boolean, orderStatusType: string, holdByReservation: boolean) {
    const isPayConfirm = targetStatusType === 'PAY_DONE' && (orderStatusType === 'DEPOSIT_WAIT' || holdByReservation);

    const flag = checkedRowList.map((row: any): any => row.taskMessage).every((value: any): any => value === false);
    if (orderStatusType === 'PRODUCT_PREPARE' || orderStatusType === 'DELIVERY_PREPARE') {
      let message: any = '';
      switch (targetStatusType) {
        case 'DELIVERY_PREPARE':
          message = this.$t('ORDER_LIST_GRIDS_TARGET_DELIVERY_PREPARE_MESSAGE');
          break;
        case 'PAY_DONE':
          message = this.$t('ORDER_LIST_GRIDS_TARGET_PAY_DONE_MESSAGE');
          break;
        case 'DELIVERY_ING':
          message = this.$t('ORDER_LIST_GRIDS_TARGET_DELIVERY_ING_MESSAGE');
          break;
        case 'PRODUCT_PREPARE':
          message = this.$t('ORDER_LIST_GRIDS_TARGET_PRODUCT_PREPARE_MESSAGE');
          break;
        default:
          break;
      }
      if (!flag && !confirm(message)) {
        return;
      }
    }

    this.$api.putPaymentsConfirm(checkedRowList.map(item => item.orderNo)).then(() => {
      if (isPayConfirm) {
        alert(this.$t('ORDER_LIST_GRIDS_PAY_CONFIRM_HANDLE_DONE'));
      } else {
        alert(this.$t('ORDER_LIST_GRIDS_HANDLE_DONE'));
      }
      this.search(1, this.size);
    });
  }
  private checkGroupRow(ev: any): void {
    let beforeCheck = this.getCheckedRowKeys();
    setTimeout(() => {
      this.$nextTick(() => {
        let afterRow = this.getCheckedRowKeys();
        let checkRow: any = [];
        if (ev.currentTarget.checked) {
          checkRow = afterRow.filter((item: any): any => {
            if (beforeCheck.length === 0) {
              return item;
            } else {
              if (beforeCheck.indexOf(item) < 0) {
                return item;
              }
            }
          });
        } else {
          checkRow = beforeCheck.filter((item: any): any => {
            if (afterRow.indexOf(item) < 0) {
              return item;
            }
          });
        }
        let row: any = [];
        checkRow.map((cr: any): any => {
          row.push(this.getRowItems(cr));
        });
        row.forEach((item1: any): any => {
          this.orderListContent.forEach((item2: any): any => {
            if (item2.orderNo === item1.orderNo) {
              if (ev.currentTarget.checked) {
                this.checks(item2.orderProductOptionNo);
              } else {
                this.uncheck(item2.orderProductOptionNo);
              }
            }
          });
        });
      });
    }, 0);
  }
  private checks(rowKey: any): any {
    return (this.$refs.gridBottom as any).check(rowKey);
  }
  private uncheck(rowKey: any): any {
    return (this.$refs.gridBottom as any).uncheck(rowKey);
  }
  private getCheckedRowKeys(): any {
    return (this.$refs.gridBottom as any).getCheckedRowKeys();
  }
  private onClickGridItem({ rowKey, columnName }) {
    switch (columnName) {
      case 'procEachBtn':
        this.changeDepositStatus(rowKey);
    }
  }
}
